export default __webpack_public_path__ + "static/media/2.0a72f472.jpg";